import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Observable, Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {DiscountService} from './service-discount/discount.service';
import {DiscountModel} from '../../../models/DiscountModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {ProviderAnagrafService} from '../../general-services/service-provider-anagraf/provider-anagraf.service';
import {RegionService} from '../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import * as toastr from 'toastr';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss']
})
export class DiscountComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  displayedColumns: Array<string>;
  dataSource: DiscountModel[];
  isDiscountSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  getFirstProviderObservable: Observable<any>;
  getAllRegionObservable: Observable<any>;
  getAllLocalCustomerObservable: Observable<any>;
  offset: Offset;
  selectedRowIndex: number;

  filter: DiscountModel;
  showNewEditDelete: boolean;
  showFilter: boolean;
  providerData: any;
  regionData: any;
  localCustomerData: any;

  sectionId: string;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private discountService: DiscountService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private providerService: ProviderAnagrafService,
              private userService: UsersService,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.CONTRACTUAL_DATA;

  }


  ngOnInit() {
    this.isDiscountSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;

    this.displayedColumns = ['numAnno', 'regionDesc', 'localCustomerDesc', 'Discount', 'actions'];

    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.DISCOUNT_OFFSET);
    this.getSessionStorageFilter();
    this.init();
  }


  init() {
    if (!this.reportSection) {
      this.showFilter = false;
      this.getDataPage(this.offset, this.filter);
    } else {
      this.showFilter = true;
    }
    this.loaderService.display(false);
  }

  getDataPage(offset: Offset, filter: DiscountModel) {
    this.loaderService.display(true);
    this.getPageSubscribe = this.discountService.getPage(offset, filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.listData.sort = this.sort;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const discountData = this.dataSource.find(data => data.id === id);
    const list: GenericArray[] = [
      {id: 'Year', value: this.toCustomString(discountData.numAnno)},
      {id: 'Provider Cod', value: this.toCustomString(discountData.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString(discountData.provider.description)},
      {id: 'Region Cod', value: this.toCustomString(discountData.region.cod)},
      {id: 'Region Description', value: this.toCustomString(discountData.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString(discountData.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString(discountData.localCustomer.description)},
      {id: 'Discount', value: this.toCustomStringNumberPerc(discountData.discount)},
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.DISCOUNT_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.loaderService.display(true);
      this.deleteElementSubscribe = this.discountService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Discount was deleted with success', 'Success');
              this.getDataPage(this.offset, this.filter);
            } else {
              toastr.error('Discount with id was not deleted', 'Error');
            }
          }, error =>  {
            this.loaderService.display(false);
            toastr.error('Contractual Data with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
    this.loaderService.display(false);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }

    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

    showNewMassive() {
    let showNewMassive = false;
    if (this.canInsert) {
      showNewMassive = true;
    }
    if (this.reportSection) {
      showNewMassive = false;
    }
    return showNewMassive;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DISCOUNT_FILTER));
    this.filter = filter_ ? filter_ : new DiscountModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
  }

}
